import { createContext } from "react";

export const ArticulosTemporadasContext = createContext()
export const ArticulosTemporadasFormContext = createContext()
export const ArticulosTemporadasReportContext = createContext()